import { BASE_PATH as v, BaseAPI as G, operationServerMap as p } from "../base.js";
import { DUMMY_BASE_URL as h, assertParamExists as c, createRequestFunction as u, serializeDataIfNeeded as _, setSearchParams as O, toPathString as S } from "../common.js";
import b from "axios";
var A = function(r) {
  return {
    systemVersionCopyObject: async (n, t, i, s, e, o = {}) => {
      c("systemVersionCopyObject", "endpoint", n), c("systemVersionCopyObject", "sourceBucketName", t), c("systemVersionCopyObject", "sourceObjectName", i), c("systemVersionCopyObject", "destinationBucketName", s), c("systemVersionCopyObject", "destinationObjectName", e);
      const l = new URL("/system_version/copy_object", h);
      let a;
      r && (a = r.baseOptions);
      const d = {
        method: "POST",
        ...a,
        ...o
      }, V = {}, y = {};
      n !== void 0 && (y.endpoint = n), t !== void 0 && (y.sourceBucketName = t), i !== void 0 && (y.sourceObjectName = i), s !== void 0 && (y.destinationBucketName = s), e !== void 0 && (y.destinationObjectName = e), O(l, y);
      let B = a && a.headers ? a.headers : {};
      return d.headers = {
        ...V,
        ...B,
        ...o.headers
      }, {
        url: S(l),
        options: d
      };
    },
    systemVersionCreate: async (n, t = {}) => {
      c("systemVersionCreate", "systemVersionCreateCommand", n);
      const i = new URL("/system_version", h);
      let s;
      r && (s = r.baseOptions);
      const e = {
        method: "POST",
        ...s,
        ...t
      }, o = {}, l = {};
      o["Content-Type"] = "application/json", O(i, l);
      let a = s && s.headers ? s.headers : {};
      return e.headers = {
        ...o,
        ...a,
        ...t.headers
      }, e.data = _(n, e, r), {
        url: S(i),
        options: e
      };
    },
    systemVersionGetAllLatestVersion: async (n = {}) => {
      const t = new URL("/system_version/get_all_latest_version", h);
      let i;
      r && (i = r.baseOptions);
      const s = {
        method: "GET",
        ...i,
        ...n
      }, e = {};
      O(t, {});
      let o = i && i.headers ? i.headers : {};
      return s.headers = {
        ...e,
        ...o,
        ...n.headers
      }, {
        url: S(t),
        options: s
      };
    },
    systemVersionGetBucketStaticWebsite: async (n, t, i = {}) => {
      c("systemVersionGetBucketStaticWebsite", "bucketName", n);
      const s = new URL("/system_version/bucket_static_website", h);
      let e;
      r && (e = r.baseOptions);
      const o = {
        method: "GET",
        ...e,
        ...i
      }, l = {}, a = {};
      t !== void 0 && (a.endpoint = t), n !== void 0 && (a.bucketName = n), O(s, a);
      let d = e && e.headers ? e.headers : {};
      return o.headers = {
        ...l,
        ...d,
        ...i.headers
      }, {
        url: S(s),
        options: o
      };
    },
    systemVersionGetGrayVersion: async (n, t = {}) => {
      c("systemVersionGetGrayVersion", "systemType", n);
      const i = new URL("/system_version/get_gray_version", h);
      let s;
      r && (s = r.baseOptions);
      const e = {
        method: "GET",
        ...s,
        ...t
      }, o = {}, l = {};
      n !== void 0 && (l.systemType = n), O(i, l);
      let a = s && s.headers ? s.headers : {};
      return e.headers = {
        ...o,
        ...a,
        ...t.headers
      }, {
        url: S(i),
        options: e
      };
    },
    systemVersionGetLatestVersion: async (n, t = {}) => {
      c("systemVersionGetLatestVersion", "systemType", n);
      const i = new URL("/system_version/get_latest_version", h);
      let s;
      r && (s = r.baseOptions);
      const e = {
        method: "GET",
        ...s,
        ...t
      }, o = {}, l = {};
      n !== void 0 && (l.systemType = n), O(i, l);
      let a = s && s.headers ? s.headers : {};
      return e.headers = {
        ...o,
        ...a,
        ...t.headers
      }, {
        url: S(i),
        options: e
      };
    },
    systemVersionGetUserVersionByBrandId: async (n, t, i = {}) => {
      c("systemVersionGetUserVersionByBrandId", "systemType", n), c("systemVersionGetUserVersionByBrandId", "brandId", t);
      const s = new URL("/system_version/get_user_version_by_brand_id", h);
      let e;
      r && (e = r.baseOptions);
      const o = {
        method: "GET",
        ...e,
        ...i
      }, l = {}, a = {};
      n !== void 0 && (a.systemType = n), t !== void 0 && (a.brandId = t), O(s, a);
      let d = e && e.headers ? e.headers : {};
      return o.headers = {
        ...l,
        ...d,
        ...i.headers
      }, {
        url: S(s),
        options: o
      };
    },
    systemVersionGetUserVersionByCorpUserId: async (n, t = {}) => {
      c("systemVersionGetUserVersionByCorpUserId", "systemType", n);
      const i = new URL("/system_version/get_user_version_by_corp_user_id", h);
      let s;
      r && (s = r.baseOptions);
      const e = {
        method: "GET",
        ...s,
        ...t
      }, o = {}, l = {};
      n !== void 0 && (l.systemType = n), O(i, l);
      let a = s && s.headers ? s.headers : {};
      return e.headers = {
        ...o,
        ...a,
        ...t.headers
      }, {
        url: S(i),
        options: e
      };
    },
    systemVersionGetUserVersionByCorpUserIdAndVersionId: async (n, t = {}) => {
      c("systemVersionGetUserVersionByCorpUserIdAndVersionId", "versionId", n);
      const i = new URL("/system_version/get_user_version_by_corp_user_id_v2", h);
      let s;
      r && (s = r.baseOptions);
      const e = {
        method: "GET",
        ...s,
        ...t
      }, o = {}, l = {};
      n !== void 0 && (l.versionId = n), O(i, l);
      let a = s && s.headers ? s.headers : {};
      return e.headers = {
        ...o,
        ...a,
        ...t.headers
      }, {
        url: S(i),
        options: e
      };
    },
    systemVersionGetUserVersionByShopId: async (n, t, i = {}) => {
      c("systemVersionGetUserVersionByShopId", "systemType", n);
      const s = new URL("/system_version/get_user_version_by_shop_id", h);
      let e;
      r && (e = r.baseOptions);
      const o = {
        method: "GET",
        ...e,
        ...i
      }, l = {}, a = {};
      n !== void 0 && (a.systemType = n), t !== void 0 && (a.shopId = t), O(s, a);
      let d = e && e.headers ? e.headers : {};
      return o.headers = {
        ...l,
        ...d,
        ...i.headers
      }, {
        url: S(s),
        options: o
      };
    },
    systemVersionGetUserVersionByShopIdAndVersionId: async (n, t, i = {}) => {
      c("systemVersionGetUserVersionByShopIdAndVersionId", "versionId", n);
      const s = new URL("/system_version/get_user_version_by_shop_id_v2", h);
      let e;
      r && (e = r.baseOptions);
      const o = {
        method: "GET",
        ...e,
        ...i
      }, l = {}, a = {};
      n !== void 0 && (a.versionId = n), t !== void 0 && (a.shopId = t), O(s, a);
      let d = e && e.headers ? e.headers : {};
      return o.headers = {
        ...l,
        ...d,
        ...i.headers
      }, {
        url: S(s),
        options: o
      };
    },
    systemVersionListBuckets: async (n, t = {}) => {
      const i = new URL("/system_version/buckets", h);
      let s;
      r && (s = r.baseOptions);
      const e = {
        method: "GET",
        ...s,
        ...t
      }, o = {}, l = {};
      n !== void 0 && (l.endpoint = n), O(i, l);
      let a = s && s.headers ? s.headers : {};
      return e.headers = {
        ...o,
        ...a,
        ...t.headers
      }, {
        url: S(i),
        options: e
      };
    },
    systemVersionListObjects: async (n, t, i, s, e, o = {}) => {
      c("systemVersionListObjects", "bucketName", n);
      const l = new URL("/system_version/objects", h);
      let a;
      r && (a = r.baseOptions);
      const d = {
        method: "GET",
        ...a,
        ...o
      }, V = {}, y = {};
      t !== void 0 && (y.endpoint = t), n !== void 0 && (y.bucketName = n), i !== void 0 && (y.prefix = i), s !== void 0 && (y.delimiter = s), e !== void 0 && (y.objectType = e), O(l, y);
      let B = a && a.headers ? a.headers : {};
      return d.headers = {
        ...V,
        ...B,
        ...o.headers
      }, {
        url: S(l),
        options: d
      };
    },
    systemVersionModifyBucketStaticWebsite: async (n, t, i, s, e = {}) => {
      c("systemVersionModifyBucketStaticWebsite", "bucketName", n);
      const o = new URL("/system_version/bucket_static_website", h);
      let l;
      r && (l = r.baseOptions);
      const a = {
        method: "POST",
        ...l,
        ...e
      }, d = {}, V = {};
      t !== void 0 && (V.endpoint = t), n !== void 0 && (V.bucketName = n), i !== void 0 && (V.indexDocument = i), s !== void 0 && (V.errorDocument = s), O(o, V);
      let y = l && l.headers ? l.headers : {};
      return a.headers = {
        ...d,
        ...y,
        ...e.headers
      }, {
        url: S(o),
        options: a
      };
    },
    systemVersionMoveSystemVersion: async (n, t = {}) => {
      c("systemVersionMoveSystemVersion", "systemVersionSortDTO", n);
      const i = new URL("/system_version/move", h);
      let s;
      r && (s = r.baseOptions);
      const e = {
        method: "POST",
        ...s,
        ...t
      }, o = {}, l = {};
      o["Content-Type"] = "application/json", O(i, l);
      let a = s && s.headers ? s.headers : {};
      return e.headers = {
        ...o,
        ...a,
        ...t.headers
      }, e.data = _(n, e, r), {
        url: S(i),
        options: e
      };
    },
    systemVersionPage: async (n, t, i = {}) => {
      c("systemVersionPage", "page", n), c("systemVersionPage", "systemVersion", t);
      const s = new URL("/system_version/page", h);
      let e;
      r && (e = r.baseOptions);
      const o = {
        method: "GET",
        ...e,
        ...i
      }, l = {}, a = {};
      if (n !== void 0) for (const [V, y] of Object.entries(n)) a[V] = y;
      if (t !== void 0) for (const [V, y] of Object.entries(t)) a[V] = y;
      O(s, a);
      let d = e && e.headers ? e.headers : {};
      return o.headers = {
        ...l,
        ...d,
        ...i.headers
      }, {
        url: S(s),
        options: o
      };
    },
    systemVersionTriggerNotice: async (n, t, i = {}) => {
      c("systemVersionTriggerNotice", "systemVersionId", n);
      const s = new URL("/system_version/trigger_notice", h);
      let e;
      r && (e = r.baseOptions);
      const o = {
        method: "POST",
        ...e,
        ...i
      }, l = {}, a = {};
      n !== void 0 && (a.systemVersionId = n), t !== void 0 && (a.noticeType = t), O(s, a);
      let d = e && e.headers ? e.headers : {};
      return o.headers = {
        ...l,
        ...d,
        ...i.headers
      }, {
        url: S(s),
        options: o
      };
    },
    systemVersionTriggerUpdate: async (n, t = {}) => {
      c("systemVersionTriggerUpdate", "systemType", n);
      const i = new URL("/system_version/trigger_update", h);
      let s;
      r && (s = r.baseOptions);
      const e = {
        method: "POST",
        ...s,
        ...t
      }, o = {}, l = {};
      n !== void 0 && (l.systemType = n), O(i, l);
      let a = s && s.headers ? s.headers : {};
      return e.headers = {
        ...o,
        ...a,
        ...t.headers
      }, {
        url: S(i),
        options: e
      };
    },
    systemVersionUpdate: async (n, t = {}) => {
      c("systemVersionUpdate", "systemVersionUpdateCommand", n);
      const i = new URL("/system_version", h);
      let s;
      r && (s = r.baseOptions);
      const e = {
        method: "PUT",
        ...s,
        ...t
      }, o = {}, l = {};
      o["Content-Type"] = "application/json", O(i, l);
      let a = s && s.headers ? s.headers : {};
      return e.headers = {
        ...o,
        ...a,
        ...t.headers
      }, e.data = _(n, e, r), {
        url: S(i),
        options: e
      };
    }
  };
}, m = function(r) {
  const n = A(r);
  return {
    async systemVersionCopyObject(t, i, s, e, o, l) {
      var a, d;
      const V = await n.systemVersionCopyObject(t, i, s, e, o, l), y = (a = r == null ? void 0 : r.serverIndex) !== null && a !== void 0 ? a : 0, B = (d = p["SystemVersionApi.systemVersionCopyObject"]) === null || d === void 0 || (d = d[y]) === null || d === void 0 ? void 0 : d.url;
      return (U, I) => u(V, b, v, r)(U, B || I);
    },
    async systemVersionCreate(t, i) {
      var s, e;
      const o = await n.systemVersionCreate(t, i), l = (s = r == null ? void 0 : r.serverIndex) !== null && s !== void 0 ? s : 0, a = (e = p["SystemVersionApi.systemVersionCreate"]) === null || e === void 0 || (e = e[l]) === null || e === void 0 ? void 0 : e.url;
      return (d, V) => u(o, b, v, r)(d, a || V);
    },
    async systemVersionGetAllLatestVersion(t) {
      var i, s;
      const e = await n.systemVersionGetAllLatestVersion(t), o = (i = r == null ? void 0 : r.serverIndex) !== null && i !== void 0 ? i : 0, l = (s = p["SystemVersionApi.systemVersionGetAllLatestVersion"]) === null || s === void 0 || (s = s[o]) === null || s === void 0 ? void 0 : s.url;
      return (a, d) => u(e, b, v, r)(a, l || d);
    },
    async systemVersionGetBucketStaticWebsite(t, i, s) {
      var e, o;
      const l = await n.systemVersionGetBucketStaticWebsite(t, i, s), a = (e = r == null ? void 0 : r.serverIndex) !== null && e !== void 0 ? e : 0, d = (o = p["SystemVersionApi.systemVersionGetBucketStaticWebsite"]) === null || o === void 0 || (o = o[a]) === null || o === void 0 ? void 0 : o.url;
      return (V, y) => u(l, b, v, r)(V, d || y);
    },
    async systemVersionGetGrayVersion(t, i) {
      var s, e;
      const o = await n.systemVersionGetGrayVersion(t, i), l = (s = r == null ? void 0 : r.serverIndex) !== null && s !== void 0 ? s : 0, a = (e = p["SystemVersionApi.systemVersionGetGrayVersion"]) === null || e === void 0 || (e = e[l]) === null || e === void 0 ? void 0 : e.url;
      return (d, V) => u(o, b, v, r)(d, a || V);
    },
    async systemVersionGetLatestVersion(t, i) {
      var s, e;
      const o = await n.systemVersionGetLatestVersion(t, i), l = (s = r == null ? void 0 : r.serverIndex) !== null && s !== void 0 ? s : 0, a = (e = p["SystemVersionApi.systemVersionGetLatestVersion"]) === null || e === void 0 || (e = e[l]) === null || e === void 0 ? void 0 : e.url;
      return (d, V) => u(o, b, v, r)(d, a || V);
    },
    async systemVersionGetUserVersionByBrandId(t, i, s) {
      var e, o;
      const l = await n.systemVersionGetUserVersionByBrandId(t, i, s), a = (e = r == null ? void 0 : r.serverIndex) !== null && e !== void 0 ? e : 0, d = (o = p["SystemVersionApi.systemVersionGetUserVersionByBrandId"]) === null || o === void 0 || (o = o[a]) === null || o === void 0 ? void 0 : o.url;
      return (V, y) => u(l, b, v, r)(V, d || y);
    },
    async systemVersionGetUserVersionByCorpUserId(t, i) {
      var s, e;
      const o = await n.systemVersionGetUserVersionByCorpUserId(t, i), l = (s = r == null ? void 0 : r.serverIndex) !== null && s !== void 0 ? s : 0, a = (e = p["SystemVersionApi.systemVersionGetUserVersionByCorpUserId"]) === null || e === void 0 || (e = e[l]) === null || e === void 0 ? void 0 : e.url;
      return (d, V) => u(o, b, v, r)(d, a || V);
    },
    async systemVersionGetUserVersionByCorpUserIdAndVersionId(t, i) {
      var s, e;
      const o = await n.systemVersionGetUserVersionByCorpUserIdAndVersionId(t, i), l = (s = r == null ? void 0 : r.serverIndex) !== null && s !== void 0 ? s : 0, a = (e = p["SystemVersionApi.systemVersionGetUserVersionByCorpUserIdAndVersionId"]) === null || e === void 0 || (e = e[l]) === null || e === void 0 ? void 0 : e.url;
      return (d, V) => u(o, b, v, r)(d, a || V);
    },
    async systemVersionGetUserVersionByShopId(t, i, s) {
      var e, o;
      const l = await n.systemVersionGetUserVersionByShopId(t, i, s), a = (e = r == null ? void 0 : r.serverIndex) !== null && e !== void 0 ? e : 0, d = (o = p["SystemVersionApi.systemVersionGetUserVersionByShopId"]) === null || o === void 0 || (o = o[a]) === null || o === void 0 ? void 0 : o.url;
      return (V, y) => u(l, b, v, r)(V, d || y);
    },
    async systemVersionGetUserVersionByShopIdAndVersionId(t, i, s) {
      var e, o;
      const l = await n.systemVersionGetUserVersionByShopIdAndVersionId(t, i, s), a = (e = r == null ? void 0 : r.serverIndex) !== null && e !== void 0 ? e : 0, d = (o = p["SystemVersionApi.systemVersionGetUserVersionByShopIdAndVersionId"]) === null || o === void 0 || (o = o[a]) === null || o === void 0 ? void 0 : o.url;
      return (V, y) => u(l, b, v, r)(V, d || y);
    },
    async systemVersionListBuckets(t, i) {
      var s, e;
      const o = await n.systemVersionListBuckets(t, i), l = (s = r == null ? void 0 : r.serverIndex) !== null && s !== void 0 ? s : 0, a = (e = p["SystemVersionApi.systemVersionListBuckets"]) === null || e === void 0 || (e = e[l]) === null || e === void 0 ? void 0 : e.url;
      return (d, V) => u(o, b, v, r)(d, a || V);
    },
    async systemVersionListObjects(t, i, s, e, o, l) {
      var a, d;
      const V = await n.systemVersionListObjects(t, i, s, e, o, l), y = (a = r == null ? void 0 : r.serverIndex) !== null && a !== void 0 ? a : 0, B = (d = p["SystemVersionApi.systemVersionListObjects"]) === null || d === void 0 || (d = d[y]) === null || d === void 0 ? void 0 : d.url;
      return (U, I) => u(V, b, v, r)(U, B || I);
    },
    async systemVersionModifyBucketStaticWebsite(t, i, s, e, o) {
      var l, a;
      const d = await n.systemVersionModifyBucketStaticWebsite(t, i, s, e, o), V = (l = r == null ? void 0 : r.serverIndex) !== null && l !== void 0 ? l : 0, y = (a = p["SystemVersionApi.systemVersionModifyBucketStaticWebsite"]) === null || a === void 0 || (a = a[V]) === null || a === void 0 ? void 0 : a.url;
      return (B, U) => u(d, b, v, r)(B, y || U);
    },
    async systemVersionMoveSystemVersion(t, i) {
      var s, e;
      const o = await n.systemVersionMoveSystemVersion(t, i), l = (s = r == null ? void 0 : r.serverIndex) !== null && s !== void 0 ? s : 0, a = (e = p["SystemVersionApi.systemVersionMoveSystemVersion"]) === null || e === void 0 || (e = e[l]) === null || e === void 0 ? void 0 : e.url;
      return (d, V) => u(o, b, v, r)(d, a || V);
    },
    async systemVersionPage(t, i, s) {
      var e, o;
      const l = await n.systemVersionPage(t, i, s), a = (e = r == null ? void 0 : r.serverIndex) !== null && e !== void 0 ? e : 0, d = (o = p["SystemVersionApi.systemVersionPage"]) === null || o === void 0 || (o = o[a]) === null || o === void 0 ? void 0 : o.url;
      return (V, y) => u(l, b, v, r)(V, d || y);
    },
    async systemVersionTriggerNotice(t, i, s) {
      var e, o;
      const l = await n.systemVersionTriggerNotice(t, i, s), a = (e = r == null ? void 0 : r.serverIndex) !== null && e !== void 0 ? e : 0, d = (o = p["SystemVersionApi.systemVersionTriggerNotice"]) === null || o === void 0 || (o = o[a]) === null || o === void 0 ? void 0 : o.url;
      return (V, y) => u(l, b, v, r)(V, d || y);
    },
    async systemVersionTriggerUpdate(t, i) {
      var s, e;
      const o = await n.systemVersionTriggerUpdate(t, i), l = (s = r == null ? void 0 : r.serverIndex) !== null && s !== void 0 ? s : 0, a = (e = p["SystemVersionApi.systemVersionTriggerUpdate"]) === null || e === void 0 || (e = e[l]) === null || e === void 0 ? void 0 : e.url;
      return (d, V) => u(o, b, v, r)(d, a || V);
    },
    async systemVersionUpdate(t, i) {
      var s, e;
      const o = await n.systemVersionUpdate(t, i), l = (s = r == null ? void 0 : r.serverIndex) !== null && s !== void 0 ? s : 0, a = (e = p["SystemVersionApi.systemVersionUpdate"]) === null || e === void 0 || (e = e[l]) === null || e === void 0 ? void 0 : e.url;
      return (d, V) => u(o, b, v, r)(d, a || V);
    }
  };
}, L = function(r, n, t) {
  const i = m(r);
  return {
    systemVersionCopyObject(s, e) {
      return i.systemVersionCopyObject(s.endpoint, s.sourceBucketName, s.sourceObjectName, s.destinationBucketName, s.destinationObjectName, e).then((o) => o(t, n));
    },
    systemVersionCreate(s, e) {
      return i.systemVersionCreate(s.systemVersionCreateCommand, e).then((o) => o(t, n));
    },
    systemVersionGetAllLatestVersion(s) {
      return i.systemVersionGetAllLatestVersion(s).then((e) => e(t, n));
    },
    systemVersionGetBucketStaticWebsite(s, e) {
      return i.systemVersionGetBucketStaticWebsite(s.bucketName, s.endpoint, e).then((o) => o(t, n));
    },
    systemVersionGetGrayVersion(s, e) {
      return i.systemVersionGetGrayVersion(s.systemType, e).then((o) => o(t, n));
    },
    systemVersionGetLatestVersion(s, e) {
      return i.systemVersionGetLatestVersion(s.systemType, e).then((o) => o(t, n));
    },
    systemVersionGetUserVersionByBrandId(s, e) {
      return i.systemVersionGetUserVersionByBrandId(s.systemType, s.brandId, e).then((o) => o(t, n));
    },
    systemVersionGetUserVersionByCorpUserId(s, e) {
      return i.systemVersionGetUserVersionByCorpUserId(s.systemType, e).then((o) => o(t, n));
    },
    systemVersionGetUserVersionByCorpUserIdAndVersionId(s, e) {
      return i.systemVersionGetUserVersionByCorpUserIdAndVersionId(s.versionId, e).then((o) => o(t, n));
    },
    systemVersionGetUserVersionByShopId(s, e) {
      return i.systemVersionGetUserVersionByShopId(s.systemType, s.shopId, e).then((o) => o(t, n));
    },
    systemVersionGetUserVersionByShopIdAndVersionId(s, e) {
      return i.systemVersionGetUserVersionByShopIdAndVersionId(s.versionId, s.shopId, e).then((o) => o(t, n));
    },
    systemVersionListBuckets(s = {}, e) {
      return i.systemVersionListBuckets(s.endpoint, e).then((o) => o(t, n));
    },
    systemVersionListObjects(s, e) {
      return i.systemVersionListObjects(s.bucketName, s.endpoint, s.prefix, s.delimiter, s.objectType, e).then((o) => o(t, n));
    },
    systemVersionModifyBucketStaticWebsite(s, e) {
      return i.systemVersionModifyBucketStaticWebsite(s.bucketName, s.endpoint, s.indexDocument, s.errorDocument, e).then((o) => o(t, n));
    },
    systemVersionMoveSystemVersion(s, e) {
      return i.systemVersionMoveSystemVersion(s.systemVersionSortDTO, e).then((o) => o(t, n));
    },
    systemVersionPage(s, e) {
      return i.systemVersionPage(s.page, s.systemVersion, e).then((o) => o(t, n));
    },
    systemVersionTriggerNotice(s, e) {
      return i.systemVersionTriggerNotice(s.systemVersionId, s.noticeType, e).then((o) => o(t, n));
    },
    systemVersionTriggerUpdate(s, e) {
      return i.systemVersionTriggerUpdate(s.systemType, e).then((o) => o(t, n));
    },
    systemVersionUpdate(s, e) {
      return i.systemVersionUpdate(s.systemVersionUpdateCommand, e).then((o) => o(t, n));
    }
  };
}, C = class extends G {
  systemVersionCopyObject(r, n) {
    return m(this.configuration).systemVersionCopyObject(r.endpoint, r.sourceBucketName, r.sourceObjectName, r.destinationBucketName, r.destinationObjectName, n).then((t) => t(this.axios, this.basePath));
  }
  systemVersionCreate(r, n) {
    return m(this.configuration).systemVersionCreate(r.systemVersionCreateCommand, n).then((t) => t(this.axios, this.basePath));
  }
  systemVersionGetAllLatestVersion(r) {
    return m(this.configuration).systemVersionGetAllLatestVersion(r).then((n) => n(this.axios, this.basePath));
  }
  systemVersionGetBucketStaticWebsite(r, n) {
    return m(this.configuration).systemVersionGetBucketStaticWebsite(r.bucketName, r.endpoint, n).then((t) => t(this.axios, this.basePath));
  }
  systemVersionGetGrayVersion(r, n) {
    return m(this.configuration).systemVersionGetGrayVersion(r.systemType, n).then((t) => t(this.axios, this.basePath));
  }
  systemVersionGetLatestVersion(r, n) {
    return m(this.configuration).systemVersionGetLatestVersion(r.systemType, n).then((t) => t(this.axios, this.basePath));
  }
  systemVersionGetUserVersionByBrandId(r, n) {
    return m(this.configuration).systemVersionGetUserVersionByBrandId(r.systemType, r.brandId, n).then((t) => t(this.axios, this.basePath));
  }
  systemVersionGetUserVersionByCorpUserId(r, n) {
    return m(this.configuration).systemVersionGetUserVersionByCorpUserId(r.systemType, n).then((t) => t(this.axios, this.basePath));
  }
  systemVersionGetUserVersionByCorpUserIdAndVersionId(r, n) {
    return m(this.configuration).systemVersionGetUserVersionByCorpUserIdAndVersionId(r.versionId, n).then((t) => t(this.axios, this.basePath));
  }
  systemVersionGetUserVersionByShopId(r, n) {
    return m(this.configuration).systemVersionGetUserVersionByShopId(r.systemType, r.shopId, n).then((t) => t(this.axios, this.basePath));
  }
  systemVersionGetUserVersionByShopIdAndVersionId(r, n) {
    return m(this.configuration).systemVersionGetUserVersionByShopIdAndVersionId(r.versionId, r.shopId, n).then((t) => t(this.axios, this.basePath));
  }
  systemVersionListBuckets(r = {}, n) {
    return m(this.configuration).systemVersionListBuckets(r.endpoint, n).then((t) => t(this.axios, this.basePath));
  }
  systemVersionListObjects(r, n) {
    return m(this.configuration).systemVersionListObjects(r.bucketName, r.endpoint, r.prefix, r.delimiter, r.objectType, n).then((t) => t(this.axios, this.basePath));
  }
  systemVersionModifyBucketStaticWebsite(r, n) {
    return m(this.configuration).systemVersionModifyBucketStaticWebsite(r.bucketName, r.endpoint, r.indexDocument, r.errorDocument, n).then((t) => t(this.axios, this.basePath));
  }
  systemVersionMoveSystemVersion(r, n) {
    return m(this.configuration).systemVersionMoveSystemVersion(r.systemVersionSortDTO, n).then((t) => t(this.axios, this.basePath));
  }
  systemVersionPage(r, n) {
    return m(this.configuration).systemVersionPage(r.page, r.systemVersion, n).then((t) => t(this.axios, this.basePath));
  }
  systemVersionTriggerNotice(r, n) {
    return m(this.configuration).systemVersionTriggerNotice(r.systemVersionId, r.noticeType, n).then((t) => t(this.axios, this.basePath));
  }
  systemVersionTriggerUpdate(r, n) {
    return m(this.configuration).systemVersionTriggerUpdate(r.systemType, n).then((t) => t(this.axios, this.basePath));
  }
  systemVersionUpdate(r, n) {
    return m(this.configuration).systemVersionUpdate(r.systemVersionUpdateCommand, n).then((t) => t(this.axios, this.basePath));
  }
};
export {
  C as SystemVersionApi,
  A as SystemVersionApiAxiosParamCreator,
  L as SystemVersionApiFactory,
  m as SystemVersionApiFp
};

//# sourceMappingURL=system-version-api.js.map